<template>
  <SprintTable />
</template>

<script>
import SprintTable from '@/components/SprintTable.vue';

export default {
  components: {
    SprintTable,
  },
};
</script>
